<template>
  <div class="three-text-cards-widget grid">
    <div class="wrapper">
      <div
        v-for="(card, index) in widget.cards"
        :key="`${card.title}-${index}`"
        class="card"
      >
        <p ref="titles" class="t-h5" v-html="nbsp(card.title)" />
        <p class="text t-p-m-160" v-html="nbsp(card.text)" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PublicThreeTextCardsWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicThreeTextCardsWidget>>()

const titles = useElementsSameHeight({
  watchSource: () => props.widget.cards
})
</script>

<style scoped lang="scss">
.wrapper {
  @include media-column(
    (
      xs: 12
    )
  );
  display: flex;
  flex-direction: column;
  gap: rem(12px);

  @include media-up(s-lg) {
    flex-direction: row;
  }
}

.card {
  display: flex;
  flex-direction: column;
  gap: rem(16px);
  padding: rem(30px) rem(20px) rem(40px);
  background-color: $layout-background-02;
  border-radius: 12px;

  @include media-up(md) {
    padding-inline: rem(24px);
  }

  @include media-up(s-lg) {
    flex: 1 0 0;
    min-height: rem(340px);
  }

  @include media-up(lg) {
    padding: rem(40px) rem(42px) rem(50px);
  }
}

.text {
  color: $layout-text-02;
}
</style>
